import { startsWith } from 'lodash';

import config from '../config';

let authToken = null;
if(config.useJWT) {
  authToken = localStorage.getItem('idToken');
}

export function setToken(newToken) {
  console.log('setting token', newToken);
  if(config.useJWT) {
    authToken = newToken;
    localStorage.setItem('idToken', authToken);
  }
  if(!newToken) {
    localStorage.removeItem('idToken');
  }
}

function getContent(res) {
  const contentType = res.headers.get('content-type');
  if (startsWith(contentType, 'application/json')) {
    return res.json();
  }
  else if (startsWith(contentType, 'text')) { 
    return res.text();
  }
  return res.blob();
}

export default function handledFetch(path, options) {
  return fetch(path, options)
    .then((res) => {
      if (res.status >= 400) {
        const err = new Error('Bad response from server');
        err.status = res.status;
        return getContent(res)
          .then(content => {
            err.content = content;
            throw err;
          });
      }
      return res;
    });
}

export function apiFetch(path, options = {}) {
  if (typeof options.body === 'object') {
    options.body = JSON.stringify(options.body);
  }
  Object.assign(options, { credentials: 'include' });
  if(authToken) {
    options.headers = options.headers || {};
    Object.assign(options.headers, { Authorization: authToken});
  }

  return handledFetch(`${config.API_URL}${path}`, options)
    .then(getContent);
}
